import { useState } from 'react';
import { Placement } from '@floating-ui/react';
import { DataSourcesTypes } from '@frontend/api-data-sources';
import { usePopoverDialog } from '@frontend/design-system';
import {
  FormFields,
  PatientSelectorScreenEnum,
  PersonSelectorPropsType,
  TransformedLegacyPerson,
  UsePersonSelectorReturnType,
} from './types';

interface UsePersonSelectorProps {
  placement?: Placement;
  initialOffset?: { x: number; y: number };
  formFields: FormFields;
  clientLocationIds?: DataSourcesTypes.AccessDataResponse['ClientLocations'];
}

const defaultFormFields: FormFields = {
  firstName: { value: '', required: true },
  lastName: { value: '', required: true },
  phoneNumber: { value: '', required: true },
  notes: { value: '' },
};

export const usePersonSelector = ({
  formFields,
  placement,
  initialOffset,
  clientLocationIds = [],
}: UsePersonSelectorProps): UsePersonSelectorReturnType => {
  const [personSelectorScreen, setPersonSelectorScreen] = useState(PatientSelectorScreenEnum.PERSON_SEARCH);
  const [selectedPerson, setSelectedPerson] = useState<TransformedLegacyPerson | null>(null);
  const personSelectorDialogProps = usePopoverDialog({
    placement: placement ?? 'bottom-start',
    initialOffset: initialOffset,
  });

  const personSelectorProps: PersonSelectorPropsType = {
    setSelectedPerson,
    formFields: formFields ?? defaultFormFields,
    personSelectorScreen,
    clientLocationIds,
    setPersonSelectorScreen,
  };

  return {
    selectedPerson,
    personSelectorDialogProps,
    personSelectorProps: personSelectorProps,
  };
};
